<template>
    <div class="tw:flex tw:flex-col tw:gap-4 tw:pb-4">
        <!--
            Dispatcher de zonas (FIX del bug de master):
            - `tipoSvg === 2` (Leaflet 3D) → SeccionesComponent
            - `tipoSvg === 1` (antifluo) + `tipoProcesoOnline === 2` (secciones)
              → SeccionesComponent (regiones anexas con secciones y plazas)
            - Resto → zonas planas con VenueMapCard + ZoneTableCard
        -->
        <SeccionesComponent
            v-if="tipoSvg === 2 || (tipoSvg === 1 && tipoProcesoOnline === 2)"
            :renovacion="renovacion"
            :hide-header="true"
            @terminar="onTerminar"
        />
        <!-- tipo_svg=2 (or null): Flat zones with venue map + table -->
        <template v-else>
            <VenueMapCard
                :svg-markup="svgRecinto"
                :zones="zonas"
                :selected-zone-id="zonaSeleccionada?.id ?? null"
                :loading="loadingZonas"
                @zone-click="onSelectZona"
            />
            <ZoneTableCard
                :zones="zonas"
                :loading="loadingZonas"
                :title="$t('perfil.cambio_asiento.listado_sectores')"
                @select="onSelectZona"
            />
        </template>
    </div>
</template>

<script setup>
    import SeccionesComponent from '@/components/frontend/abonos/nuevo/SeleccionarAsientoConSecciones/SeccionesComponent.vue';
    import VenueMapCard from '@/modules/front/ticketing/VenueMapCard.vue';
    import ZoneTableCard from '@/modules/front/ticketing/ZoneTableCard.vue';

    defineProps({
        /** Tipo de SVG del recinto: 1 = antifluo, 2 = Leaflet 3D */
        tipoSvg: {
            type: Number,
            default: null,
        },
        /** Tipo de proceso online: 1 = regiones, 2 = secciones, 3 = mapa-general */
        tipoProcesoOnline: {
            type: Number,
            default: null,
        },
        /** SVG del recinto (para VenueMapCard en tipo_svg=2) */
        svgRecinto: {
            type: String,
            default: '',
        },
        /** Listado de zonas planas (para VenueMapCard/ZoneTableCard en tipo_svg=2) */
        zonas: {
            type: Array,
            default: () => [],
        },
        /** Indica si se están cargando las zonas */
        loadingZonas: {
            type: Boolean,
            default: false,
        },
        /** Zona actualmente seleccionada por el usuario */
        zonaSeleccionada: {
            type: Object,
            default: null,
        },
        /**
         * ¿El abonado tiene `descuento.renovacion === true`? Se propaga al
         * `SeccionesComponent` legacy para que mande `renovacion=true` en la
         * query del endpoint de regiones anexas (sólo antifluo + secciones).
         */
        renovacion: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits(['seleccionar-zona']);

    /**
     * Cuando el usuario selecciona una región/zona en SeccionesComponent,
     * emitimos el evento para que el composable la asigne como zona seleccionada.
     */
    function onTerminar(zona) {
        emit('seleccionar-zona', zona);
    }

    /**
     * Cuando el usuario selecciona una zona en VenueMapCard o ZoneTableCard,
     * emitimos el evento para que el composable la asigne como zona seleccionada.
     */
    function onSelectZona(zona) {
        emit('seleccionar-zona', zona);
    }
</script>
